import { PACKAGES_LIST_REQUEST, PACKAGES_LIST_SUCCESS, PACKAGES_LIST_FAILURE } from '../actions/packageActions';

const initialState = {
  loading: false,
  list: [],
  pagination: {},
  error: null,
};

export default function packages(state = initialState, action) {
  switch (action.type) {
    case PACKAGES_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case PACKAGES_LIST_SUCCESS: {
      const payload = action.payload;
      const items = payload?.data?.items || payload?.data || payload?.items || [];
      const pagination = {
        totalCount: payload?.data?.totalCount || payload?.totalCount || items.length || 0,
      };
      return { ...state, loading: false, list: items, pagination };
    }
    case PACKAGES_LIST_FAILURE:
      return { ...state, loading: false, error: action.error || 'Failed to fetch packages' };
    default:
      return state;
  }
}


